<app-alert [alertType]="alertType" [displayCloseBtn]="displayCloseBtn" (closeClick)="closeClick.emit()">
  <ng-container *ngComponentOutlet="
    component;
    ndcDynamicInputs: componentInput;
  "></ng-container>
</app-alert>
